<template>
    <div class="empSearch">
        <div class="text-xs-center mt-4 blue--text"><h2><v-icon class="blue--text">mdi-account-search</v-icon>  ค้นหาผู้รับบริการ (ผู้ประเมิน)</h2></div>
        <v-layout row wrap>
            <v-flex xs12 sm8 md6 offset-md3 offset-sm2>
                <v-text-field
                        @keyup="searchEmp($event)" @keypress.enter="searchEmp()"  name="search" class="input" placeholder="Search.." v-model="search_val"  hint="* ค้นหาชื่อ, นามสกุล, เบอร์โทร, รหัสพนักงาน, username อย่างใดอยางหนึ่ง" autocomplete="off"
                        persistent-hint
                ></v-text-field>

                <!--<div class="mt-3">-->
                    <!--<v-btn class="green white&#45;&#45;text" @click="searchEmp()">ค้นหา</v-btn>-->
                <!--</div>-->
            </v-flex>
        </v-layout>

        <v-layout row class="mt-3" v-if="emp_list.hasOwnProperty('row_data')">
            <v-flex xs12 sm8 md6 offset-md3 offset-sm2>
                <v-card>
                    <v-list class="pt-0 pb-0">
                        <v-subheader class="brown lighten-5">ผลการค้นหาด้วยคำว่า&nbsp;&nbsp;<span class="red--text"> " {{ search_val }} " </span></v-subheader>

                        <v-alert v-if="emp_list.hasOwnProperty('row_data')&&emp_list.row_data==0" class="ma-0"
                                 :value="true"
                                 color="error"
                                 icon="warning"
                                 outline
                        >
                            <span>ไม่พบข้อมูลพนักงาน</span>
                        </v-alert>

                        <v-list-tile v-else v-for="(emp, index) in emp_list.result" :key="index" @click="setSelectedEmp(emp)" >
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    <v-layout row>
                                        <v-flex  xs1 sm1>
                                            {{ index+1 }}
                                        </v-flex>
                                        <v-flex  xs11 sm11>
                                            {{ emp.FULL_NAME_SERACH }} ({{ emp.EM_NICKNAME }}{{ emp.EORG_04!='Other' ? '/'+emp.EORG_04:'' }})
                                        </v-flex>
                                    </v-layout>
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>


                    </v-list>
                </v-card>
            </v-flex>

        </v-layout>
        <!--<v-layout row class="mt-3">-->
            <!--<v-flex xs12 sm8 md6 offset-md3 offset-sm2>-->
                <!--<div class="mt-3">-->
                    <!--MY QR :  <qr-code :size="100" :text="getLocalItem().user_id"></qr-code>-->
                <!--</div>-->
            <!--</v-flex>-->
        <!--</v-layout>-->


    </div>
</template>

<script>

    import EventBus from '@/EventBus'
    import axios from '@/axios'
    import _ from 'lodash'

    export default{
        name:"EmpSearch",
        props:{
            qsearch:String
        },
        data(){
            return{
                emp_list:[],
                search_val:this.qsearch,
            }
        },
        created(){
            this.searchEmp()
            this.searchEmp = _.debounce(this.searchEmp,1000);
        },
        mounted(){
            window.scrollTo(0,0)
            EventBus.$emit('set_navigation', {title:'เลือกบริการ',back_route:'evaluate',params:{eventbus_call:'clear_selected_service'}})
        },
        methods:{
            setSelectedEmp(emp){
                this.$emit('set_selected_emp',emp)
                this.$emit('set_qsearch',this.search_val)
            },
            async searchEmp(event)
            {
                if(event){
                    this.search_val = event.target.value
                }
                let query_string = this.search_val
                try{
                    const uri = '/SearchStaff'
                    const localitem = this.getLocalItem()
                    const res = await axios.post(uri, {
                        username:localitem.user_id,
                        q:query_string,
                        key:'Zjgfkoerhg2'
                    })
                    this.emp_list = res.data
                }catch(err)
                {
                    this.emp_list = []
                    console.log(err.message)
                }
            },
        }
    }
</script>

<style scoped>
    .v-list div[role=listitem], v-subheader{
        border-bottom: 1px solid #f0f0f0 !important;
    }
</style>